import { useState, useEffect, useContext } from "react";
import { AppContext } from "../../scripts/context";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";

import Brand from "../BrandText";
import ToggleTheme from "./ToggleTheme";

import NavStyle from "./style";
import { utils } from "ethers";

export default function Navbar() {
  const {
    state,
    state: { user, getShortenAddress, connectWallet },
    disconnect,
  } = useContext(AppContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [newBalance, setNewBalance] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    });

    state.provider?.on("block", async () => {
      const balanceSelectedAddress = await state.provider.getBalance(
        state.user.address
      );
      if (
        String(utils.formatUnits(balanceSelectedAddress)).match(
          /^-?\d+(?:\.\d{0,4})?/
        )?.[0] !== state.user.balance
      ) {
        setNewBalance(
          String(utils.formatUnits(balanceSelectedAddress)).match(
            /^-?\d+(?:\.\d{0,4})?/
          )?.[0]
        );
      }
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NavStyle isScrolled={isScrolled}>
      <div className="container">
        <div className="nav-container">
          <Brand className="brand" />

          <div className="addres-info__toogle-theme">
            {user.address ? (
              <div className="addres-info">
                <span className="addres-info__balance">
                  {newBalance || user.balance}{" "}
                  {process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL}
                </span>
                <div className="wallet-address-button-container">
                  <button className="wallet-address-button">
                    <div>
                      <Jazzicon
                        diameter={20}
                        seed={jsNumberForAddress(user.address)}
                      />

                      <span className="connect-wallet-button__text">
                        {getShortenAddress(user.address)}
                      </span>
                    </div>

                    <svg
                      width="8"
                      height="6"
                      viewBox="0 0 8 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 1.5L4 4.5L1 1.5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  <div className="dropdown-settings">
                    <button onClick={disconnect}>
                      Disconnect
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.68781 12.65C5.0468 12.65 5.33781 12.359 5.33781 12C5.33781 11.641 5.0468 11.35 4.68781 11.35L4.68781 12.65ZM4.68781 1.65C5.0468 1.65 5.33781 1.35898 5.33781 1C5.33781 0.641015 5.0468 0.35 4.68781 0.35L4.68781 1.65ZM8.96756 2.68649C8.70941 2.43703 8.29791 2.44409 8.04846 2.70224C7.799 2.96039 7.80606 3.37189 8.06421 3.62134L8.96756 2.68649ZM12 6.52062L12.4517 6.98805C12.5784 6.86558 12.65 6.69688 12.65 6.52062C12.65 6.34437 12.5784 6.17567 12.4517 6.0532L12 6.52062ZM8.06421 9.4199C7.80606 9.66936 7.799 10.0809 8.04846 10.339C8.29791 10.5972 8.70941 10.6042 8.96756 10.3548L8.06421 9.4199ZM3.88097 5.87062C3.52199 5.87062 3.23097 6.16164 3.23097 6.52062C3.23097 6.87961 3.52199 7.17062 3.88097 7.17062L3.88097 5.87062ZM11.9902 7.17062C12.3492 7.17062 12.6402 6.87961 12.6402 6.52062C12.6402 6.16164 12.3492 5.87062 11.9902 5.87062L11.9902 7.17062ZM4.68781 11.35L2.82958 11.35L2.82958 12.65L4.68781 12.65L4.68781 11.35ZM2.82958 11.35C2.15685 11.35 1.65 10.8288 1.65 10.2321L0.350005 10.2321C0.350005 11.5884 1.48124 12.65 2.82958 12.65L2.82958 11.35ZM1.65 10.2321L1.65001 2.76792L0.350005 2.76792L0.350005 10.2321L1.65 10.2321ZM1.65001 2.76792C1.65001 2.17124 2.15685 1.65 2.82958 1.65L2.82958 0.35C1.48124 0.35 0.350005 1.41163 0.350005 2.76792L1.65001 2.76792ZM2.82958 1.65L4.68781 1.65L4.68781 0.35L2.82958 0.35L2.82958 1.65ZM8.06421 3.62134L11.5483 6.98805L12.4517 6.0532L8.96756 2.68649L8.06421 3.62134ZM11.5483 6.0532L8.06421 9.4199L8.96756 10.3548L12.4517 6.98805L11.5483 6.0532ZM3.88097 7.17062L11.9902 7.17062L11.9902 5.87062L3.88097 5.87062L3.88097 7.17062Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <button onClick={connectWallet} id="connect-wallet" type="button">
                Connect Wallet
              </button>
            )}
            <ToggleTheme />
          </div>
        </div>
      </div>
    </NavStyle>
  );
}
